import { render, staticRenderFns } from "./ModelCard.vue?vue&type=template&id=93580a10"
import script from "./ModelCard.vue?vue&type=script&lang=js"
export * from "./ModelCard.vue?vue&type=script&lang=js"
import style0 from "./ModelCard.vue?vue&type=style&index=0&id=93580a10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports